import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import { TeamStudentState } from "@/store/teams/state";
import { PropType } from "vue/dist/vue";
import { generateAvatar } from "@/utils/utils";
import NameTag from "@/components/common/name-tag/name-tag.vue";
import { RoomStore, useRoomStore } from "@/hooks/use-room-store";
import { RoleView, usePage } from "@/hooks/use-page";
import { isUserPublishedAudio } from "@/store/calling/utils";
import { MODULES, vuexName } from "@/store/utils";

export default defineComponent({
  components: { NameTag },
  props: {
    member: {
      type: Object as PropType<TeamStudentState>,
      required: true,
    },
    teamColor: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const { getters } = useStore();
    const { oneStudentIds } = useRoomStore(RoomStore.Teacher);
    const { isClassPage } = usePage(RoleView.Teacher);
    const isOnline = computed<boolean>(() => getters[vuexName(MODULES.CALLING.GETTERS.GET_IS_CALLING_HAS_USER_BY_ID)](props.member.id));
    const isAudioPublished = computed<boolean>(() => isUserPublishedAudio({ userId: props.member.id, gettersOrRootGetters: getters }));
    const isMuted = computed(() => isClassPage.value && !isAudioPublished.value);
    const isOne = computed(() => oneStudentIds.value.includes(props.member.id));
    return { generateAvatar, isOnline, isMuted, isOne };
  },
});
